;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["status_api_url", "request_type", "callback_url", "payment_url", "bill_ref", "gateway"],
  name: "fdh-bank-gateway",
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      service_name: null,
      agent_fee: 0,
      fee: 0,
      total_amount: 0,
      loading: false,
      invoice_number: null,
      msisdn: null,
      validated: false,
      changeset: {},
      payment: {}
    };
  },

  computed: {
    validDataAdded: function validDataAdded() {
      return this.msisdn && this.msisdn.length > 0;
    }
  },
  mounted: function mounted() {
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.service_name = this.$attrs["service_name"];
    this.invoice_number = this.$attrs["invoice_no"];
    this.set_total_amount();
  },
  methods: {
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    },
    checkNumber: function checkNumber(number) {
      if (number.isValid) {
        this.msisdn = number.number.e164;
      }
    },
    submit_payment: function submit_payment() {
      var _this = this;

      var payload = {
        msisdn: this.msisdn,
        client_invoice_ref: this.bill_ref,
        amount: this.total_amount,
        gateway: this.gateway,
        invoice_number: this.invoice_number
      };
      _axios2.default.post(this.payment_url, payload).then(function (resp) {
        if (resp.data.status === "ok") {
          _this.loading = false;
          _this.validated = true;
          _this.payment = resp.data.payment;
          _sweetalert2.default.fire({
            icon: "info",
            text: "Use the code sent to your phone to authorize payment. \nClick 'Complete' button once paid."
          });
        } else {
          _this.changeset = {};
          _this.loading = false;
          _this.validated = false;
          _sweetalert2.default.fire({
            icon: "error",
            text: "Payment failed. Please try again later."
          });
        }
      }).catch(function (error) {});
    },
    query_payment_status: function query_payment_status() {
      var _this2 = this;

      _axios2.default.post(this.status_api_url, {
        amountPaid: this.payment.amountPaid,
        msisdn: this.msisdn,
        gateway: this.gateway,
        code: this.payment.code,
        datetime: this.payment.datetime,
        client_invoice_ref: this.bill_ref,
        invoice_number: this.invoice_number
      }).then(function (response) {
        if (response.data.status === "ok") {
          _this2.loading = false;
          _this2.validated = true;
          _this2.translate(response.data);
        }
      }).catch(function (error) {
        _this2.loading = false;
        _sweetalert2.default.fire({
          icon: "error",
          text: "Your Payment has not been Received. \nIf money has been deducted from your account \nkindly wait for a few minutes then click 'complete'  again."
        });
      });
    },
    translate: function translate(response) {
      if (this.callback_url != null && this.callback_url.length > 0) {
        window.top.location.href = this.callback_url;
      } else {
        _sweetalert2.default.fire({
          icon: "success",
          title: "Payment Info",
          text: "Payment was successful."
        });
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"fdhModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('invoice-summary',{attrs:{"invoice":_vm.invoice,"gateway_name":"FDH Bank Smartpay","currency":_vm.currency,"online_convenience_fee":_vm.fee,"total_amount":_vm.total_amount,"amount_net":_vm.invoice_amount}}),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.changeset.message != null)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.changeset.message))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('span',{staticClass:"spinner-border",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v("Please wait, loading ...\n                  ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"msisdn"}},[_vm._v("Mobile Number")]),_vm._v(" "),_c('vue-tel-input',{staticClass:"form-control",class:{ 'is-invalid': 'msisdn' in _vm.changeset },on:{"validate":_vm.checkNumber},model:{value:(_vm.msisdn),callback:function ($$v) {_vm.msisdn=$$v},expression:"msisdn"}}),_vm._v(" "),('msisdn' in _vm.changeset)?_c('div',{staticClass:"invalid-feedback"},[_c('span',[_vm._v(_vm._s(_vm.changeset.msisdn))])]):_vm._e()],1),_vm._v(" "),(!_vm.validated)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"button","disabled":!_vm.validDataAdded},on:{"click":function($event){return _vm.submit_payment()}}},[_vm._v("Proceed")])]),_vm._v(" "),_vm._m(1)]):_vm._e()])]),_vm._v(" "),(_vm.validated)?_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.query_payment_status}},[_vm._v("Complete")])]):_vm._e()],1)])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('a',{staticClass:"btn btn-light btn-block",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0211797c", __vue__options__)
  } else {
    hotAPI.reload("data-v-0211797c", __vue__options__)
  }
})()}